import React, { useState, useEffect } from 'react'
import '../../Styles/RiskContainer.css'
import Loading from '../../Common/ui/Loading'
import InitiationSelect from 'src/Common/Icon/InitiationSelect'
import ApprovalSelect from 'src/Common/Icon/ApprovalSelect'
import AnalyseSelect from 'src/Common/Icon/AnalyseSelect'
import MonitoringSelect from 'src/Common/Icon/MonitoringSelect'
import { APPROVAL, INITIATION, OWNED, RAISED, ALL } from 'src/Entities/RiskTypes'
import { cn } from 'src/lib/utils'
import { useNavigate, useParams } from 'react-router'
import * as RoutePath from '../../Entities/RoutePath'
import IssueRaisedComponent from './IssueRaisedComponent'
import { useIssueStore } from './store/IssueStore'

const IssueContainer = () => {
    const loginId = localStorage.getItem('userId')
    const { getIssueDetails, getIssueDetailsCount } = useIssueStore()

    const navigate = useNavigate()
    const { type } = useParams()

    const [ value, setValue ] = useState(3)
    const [ riskType, setriskType ] = useState(1)
    const [ selectedMenu, setSelectedMenu ] = useState(value === 1 ? APPROVAL : INITIATION)

    const [ headerTabs, setHeaderTabs ] = useState([
        {
            id: 1,
            name: 'Analyze & Plan',
            count: 0,
            selected: true,
            defImg: <InitiationSelect isActive={true} />,
            selImg: <InitiationSelect isActive={false} />,
            show: true
        },
        {
            id: 2,
            name: 'Monitoring',
            count: 0,
            selected: true,
            defImg: <ApprovalSelect isActive={true} />,
            selImg: <ApprovalSelect isActive={false} />,
            show: true
        },
        {
            id: 3,
            name: 'Pending for Review',
            count: 0,
            selected: true,
            defImg: <AnalyseSelect isActive={true} />,
            selImg: <AnalyseSelect isActive={false} />,
            show: true
        },
        {
            id: 4,
            name: 'Close',
            count: 0,
            selected: true,
            defImg: <MonitoringSelect isActive={true} />,
            selImg: <MonitoringSelect isActive={false} />,
            show: true
        }
    ])
    const [ loading, setLoading ] = useState(false)

    useEffect(() => {
        const tabValue = value
        setLoading(true)

        const apiCalls = headerTabs?.map((ele) => {
            if (ele.id !== riskType) {
                return getIssueDetailsCount(1, 8, tabValue, ele.id, loginId)
            } else {
                return getIssueDetails(1, 30, tabValue, ele.id, loginId)
            }
        })

        Promise.all(apiCalls)
            .then(() => {
                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching issue data:', error)
                setLoading(false) // still hide loading even if some fail
            })

        setHeaderTabs((prevState) => {
            return prevState.map(ele => {
                let data = {}
                // if (ele.id === 1 && value === 2) {
                //     data = { ...ele, show: false }
                // } else {
                // }
                data = { ...ele, show: true }
                // if (+riskType === +data.id) {
                //     data = { ...data, selected: true }
                // } else {
                //     data = { ...data, selected: false }
                // }
                return data
            })
        })
    }, [ value, riskType ])

    useEffect(() => {
        if (type) {
            setHeaderTabs((prevState) => prevState?.map((mapDt) => {
                if (mapDt?.name === type) {
                    setriskType(mapDt?.id)
                    setSelectedMenu(mapDt?.id)
                    return { ...mapDt, selected: true }
                } else {
                    return { ...mapDt, selected: false }
                }
            }))
        }
    }, [type])

    const handleSelect = (menu, name) => {
        setriskType(menu)
        navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.URI + `/${name}`)
        setSelectedMenu(menu)
    }

    const handleTabChange = (event) => {
        setValue(event)
        if (event === RAISED || event === ALL) {
            setriskType(1)
        } else {
            setriskType(1)
        }
    }

    return (
        <div className='risk-container'>
            <div className='flex flex-row justify-between items-center mx-5 pt-[10px]'>
                <div className='my-2'>
                    <div style={{ display: 'flex', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '100px', height: '40px', width: 'fit-content', padding: '0', overflow: 'hidden' }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '6px 12px',
                                margin: '5px',
                                borderRadius: '100px',
                                cursor: 'pointer',
                                backgroundColor: value === ALL ? 'hsl(var(--primary))' : '',
                                color: value === ALL ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                transition: 'background-color 0.3s, color 0.3s'
                            }}
                            className={cn(value === ALL ? '' : '!font-regular', 'text-h5')}
                            onClick={() => handleTabChange(ALL)}
                        > All </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '6px 12px',
                                margin: '5px',
                                borderRadius: '100px',
                                cursor: 'pointer',
                                backgroundColor: value === RAISED ? 'hsl(var(--primary))' : '',
                                color: value === RAISED ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                transition: 'background-color 0.3s, color 0.3s'
                            }}
                            className={cn(value === RAISED ? '' : '!font-regular', 'text-h5')}
                            onClick={() => handleTabChange(RAISED)}
                        > Raised </div>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '6px 12px',
                                margin: '5px',
                                borderRadius: '100px',
                                cursor: 'pointer',
                                backgroundColor: value === OWNED ? 'hsl(var(--primary))' : '',
                                color: value === OWNED ? 'hsl(var(--card))' : 'hsl(var(--muted))',
                                transition: 'background-color 0.3s, color 0.3s'
                            }}
                            className={cn(value === OWNED ? '' : '!font-regular', 'text-h5')}
                            onClick={() => handleTabChange(OWNED)}
                        > Owned </div>
                    </div>
                </div>
            </div>

            <div className='h-[90%]'>
                {<IssueRaisedComponent headerTabs={headerTabs} riskType={value} selectedMenu={selectedMenu} handleSelect={handleSelect} />}
            </div>
            <Loading isLoading={loading } />
        </div>
    )
}

export default IssueContainer
